import axios from 'axios';
import authHeader from './auth-header';
const API_URL = process.env.REACT_APP_API_ROOT+ '/api/test/';

class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader(false) });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader(false) });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader(false) });
  }
}

export default new UserService();
